import axios from '@/axiosInstance.ts'

export type HttpChangeAccountEmailOptions = {
    urlParams: {userId: string}
    payload: {
        email: string
        password: string
    }
}
export const httpChangeAccountEmail = ({urlParams, payload}: HttpChangeAccountEmailOptions) =>
    axios.patch(`users/${urlParams.userId}/change-email`, payload)

export type HttpVerifyAccountEmailOptions = {
    urlParams: {userId: string}
    params: {token: string}
}
export const httpVerifyAccountEmail = ({urlParams, params}: HttpVerifyAccountEmailOptions) =>
    axios.patch(`users/${urlParams.userId}/verify-email`, undefined, {params})

export type HttpChangePasswordPayload = {
    currentPassword: string
    password: string
    passwordConfirmation: string
}
export const httpChangePassword = (payload: HttpChangePasswordPayload) => axios.patch('/auth/change-password', payload)

type HttpSendVerificationEmailOptions = {
    urlParams: {
        userId: string
    }
}
export const httpSendVerificationEmail = ({urlParams}: HttpSendVerificationEmailOptions) =>
    axios.post(`users/${urlParams.userId}/send-verification-email`)

type HttpCancelEmailChangeOptions = {
    urlParams: {
        userId: string
    }
}
export const httpCancelEmailChange = ({urlParams}: HttpCancelEmailChangeOptions) =>
    axios.patch(`users/${urlParams.userId}/cancel-email-change`)
